<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <!-- <Input :maxlength="100" v-model="searchForm.bannerId" placeholder="请输入配置ID" /> -->
                <div>
                  <Input :maxlength="100" v-model="searchForm.bannerName" placeholder="请输入配置名称" />
                </div>
                <div>
                  <Select v-model="searchForm.langId" placeholder="请选择语言" style="width: 150px;">
                    <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                  </Select>
                </div>
                <!-- <DatePicker :editable="false" :value="listDate" style="width:100%" format="yyyy-MM-dd" type="daterange" placeholder="请选择日期" @on-change="getListDate"></DatePicker> -->
                <Button type="primary" @click="getData()" v-if="buttonMenu['/web-banner/view']">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button v-if="buttonMenu['/web-banner/add']" type="primary" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
          <Table :data="tableData" :columns="columns">
            <template #status="{row}">
            <div>
              <i-switch v-if="buttonMenu['/web-banner/status']" :value="!row.bannerStatus" :before-change="()=>handleChangeStatus(row)" @on-change="row.bannerStatus=$event"></i-switch>
              <span v-else>{{ row.bannerStatusName }}</span>
            </div>
            </template>
            <template #imgs="{row}">
              <div>
                <img v-if="row.fileUrl" :src="row.fileUrl"  style="width:100%;cursor:pointer" @click="$viewerApi({images:[row.fileUrl]})" />
              </div>
            </template>
            <template #action="{row}">
                <div>
                    <a style="margin-left: 10px;" v-if="buttonMenu['/web-banner/edit']" @click="handleOpenEditModal(row)">编辑</a>
                    <Poptip confirm  v-if="buttonMenu['/web-banner/delete']" title="确定要删除吗？" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>
                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>
        <Modal v-model="editVisible" :title="(form.id?'编辑':'新增')+'banner'">
            <Form @submit.native.prevent :label-width="100" v-if="editVisible" :model="form" ref="formRef">
                <FormItem label="配置名称：" prop="bannerName" :rules="[{required:true,message:'请输入配置名称'}]">
                    <Input :maxlength="100" v-model="form.bannerName" />
                </FormItem>
                <FormItem label="图片：" prop="fileId" :rules="[{required:true,message:'请上传图片'}]">
                    <!-- <Upload v-model="form.fileId" /> -->
                    <div>
                      <UploadFile :uploadList="form.fileUrl?[form.fileUrl]:[]"
                      @hanldDel="form.fileId='';form.fileUrl=''" @handleSuccess="$set(form,'fileId',$event.fileId);$set(form,'fileUrl',$event.fileUrl)" >

                      </UploadFile>
                      <!-- <div v-if="form.fileUrl" style="cursor:pointer;" @click="$viewerApi({images:[form.fileUrl]})">
                          {{ form.fileUrl.split('/').at(-1) }}
                        </div> -->
                    </div>
                </FormItem>
                <FormItem label="所属语言：" prop="langId" :rules="[{required:true,message:'请选择所属语言'}]">
                    <Select v-model="form.langId" placeholder="请选择语言">
                      <Option v-for="(item,index) in langList" :key="index" :value="item.id">{{ item.chineseLangName }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="排序值：" prop="bannerSort" :rules="[{required:true,message:'请输入排序值'}]">
                    <InputNumber :min="0" v-model="form.bannerSort" :max="99999" />
                </FormItem>
                <FormItem label="跳转类型：" prop="bannerType" :rules="[{required:true,message:'请选择跳转类型'}]">
                    <Select v-model="form.bannerType" @on-change="form.bannerTarget=''">
                      <Option :value="0">短剧</Option>
                      <Option :value="1">H5内部链接</Option>
                      <Option :value="2">H5外部链接</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="form.bannerType===0" label="跳转目标：" prop="bannerTarget" required :rules="[{validator:(rule, value, callback) => {
                  if (!form.bannerTarget) {
                    callback('请输入跳转目标')
                  } else {
                    callback()
                  }
                }}]">
                  <playSearch v-model="form.bannerTarget" :name="form.playName"></playSearch>
                </FormItem>
                <FormItem v-else label="跳转目标：" prop="bannerTarget" :rules="[{required:true,message:'请输入跳转目标'}]">
                  <Input type="textarea" :autosize="{minRows:3}" show-word-limit :maxlength="120" v-model="form.bannerTarget" placeholder="请输入链接地址" />
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getWebBannerList as getBannerList, addBannerWeb as addBanner, delBanner, editBanner, getBannerInfo, changeBannerStatus } from '@/api/banner'
import playSearch from '@/components/playSearch'
import UploadFile from '@/components/Upload/uploadImg.vue'
import { getLangList } from '../../api/lang'
export default {
  components: {
    Pages,
    UploadFile,
    playSearch
  },
  data() {
    return {
      editVisible:false,
      form:{},
      langList:[],
      searchForm:{},
      listDate: [],
      submitLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: '配置id',
        //   key: 'id'
        // },
        {
          title: '配置名称',
          key: 'bannerName'
        },
        {
          title: '图片',
          key: 'fileId',
          width: 150,
          slot: 'imgs'
        },
        {
          title: '所属语言',
          key: 'langName'
        },
        {
          title: '排序值',
          key: 'bannerSort'
        },
        {
          title: '跳转类型',
          key: 'bannerTypeName'
        },
        {
          title: '跳转目标',
          key: 'bannerTarget'
        },
        {
          title: '状态',
          slot: 'status'
        },
        // {
        //   title: '登记时间',
        //   key: 'updateTime'
        // },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ]
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('server-web/web-banner')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    getData(page) {
      console.log(this.buttonMenu)

      if (page) this.page.current = page
      else this.page.current = 1
      getBannerList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    handleGetLang() {
      getLangList({ current: -1, size: -1, langStatus: true }).then(r => {
        this.langList = r.data.records
      })
    },
    handleChangeStatus(row) {
      changeBannerStatus(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData(this.page.current)
      }).catch(e => {
        this.$Message.error('操作失败')
      })
      return new Promise(() => {})
    },
    async handleOpenEditModal(row) {
      this.form = {
        bannerSort: 0
      }
      if (row) {
        const r = await getBannerInfo(row.id)
        this.form = r.data
      }
      this.editVisible = true
    },
    getListDate(data) {
      this.listDate = data
      this.searchForm.startDate = data[0]
      this.searchForm.endDate = data[1]
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editBanner : addBanner
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      delBanner(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
    this.handleGetLang()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    &>*{
        margin: 0 5px;
    }
}
.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
